export default "__VITE_ASSET__BUnEaJuQ__"